// Agent calendar — docs/real-estate/be/10-api-reference.md §A11. One
// endpoint covers every project an agent works, plus every non-cancelled
// booking in range; the Organization Staff Calendar's per-branch endpoints
// have no equivalent here. `from`/`to` are required and capped at 62 days
// apart — the month/week views this feeds never ask for more than that.
import { request } from './http';

// `query`: { from, to, agent_id?, property_id? }.
export function getAgentCalendar(query) {
  return request({ path: '/properties/agents/calendar', params: query });
}
